import 'arrive';

document.arrive('.component-custom-popups', { existing: true }, function () {
    // :not(.custom-popup--checkout) esclude il pop-up del telefono in checkout (stesso
    // stile .custom-popup ma trigger diverso, gestito a parte in _pop-up-checkout.js):
    // senza questa esclusione finirebbe "adottato" qui e mostrato a tempo invece che al
    // focus sul campo.
    const popups = document.querySelectorAll('.custom-popup:not(.custom-popup--checkout)');
    if (!popups.length) return;

    const showPopup = (popup, delay = 0) => {
        const cookieName = popup.dataset.cookieName;

        // Se il cookie esiste, non mostrare
        if (document.cookie.includes(`${cookieName}=true`)) return;

        setTimeout(() => {
            popup.classList.add('is-visible');
        }, delay);
    };

    const closePopup = (popup) => {
        const cookieName = popup.dataset.cookieName;

        // Rimuove la classe is-visible per triggerare la transizione
        popup.classList.remove('is-visible');

        // Imposta cookie valido per 1 giorno
        const expires = new Date();
        expires.setDate(expires.getDate() + 1);
        document.cookie = `${cookieName}=true; expires=${expires.toUTCString()}; path=/`;

        // Rimuove dal DOM alla fine della transizione
        const removeAfterTransition = (e) => {
            if (e.target === popup) {
                popup.removeEventListener('transitionend', removeAfterTransition);
                if (popup.parentNode) popup.parentNode.removeChild(popup);
            }
        };
        popup.addEventListener('transitionend', removeAfterTransition);
    };

    // Mostra progressivamente i popup (10 secondi di intervallo)
    popups.forEach((popup, index) => {
        const delay = index * 10000; // 10.000 ms = 10 secondi
        showPopup(popup, delay);
    });

    // Gestisci la chiusura con la X
    document.addEventListener('click', (e) => {
        if (e.target.closest('.custom-popup__close')) {
            const popup = e.target.closest('.custom-popup');
            closePopup(popup);
        }
    });

    // Chiudi popup se clicchi sul link e imposta cookie
    document.addEventListener('click', (e) => {
        const link = e.target.closest('.custom-popup__link');
        if (link) {
            const popup = link.closest('.custom-popup');
            closePopup(popup);
            // lascia il link funzionare normalmente
        }
    });
});
